import { Component } from "react";
import Chip from "@mui/material/Chip";
import { getBestFontColor } from "../../utils";

class InputWithChips extends Component {
    onClick(children) {
        this.props.onClick(children);
    }

    render() {
        let { chips } = this.props;

        return (
            <div>
                {chips.map((c, index) => {
                    let selected = false;
                    let backgroundColor = c.color && c.color.startsWith("#") ? c.color : "#" + c.color;
                    let color = c.color ? getBestFontColor(backgroundColor) : undefined;

                    if (!this.props.multipleSelction) selected = this.props.selectedValue === c.value;
                    else selected = this.props.selectedValues.find((selectedValue) => selectedValue === c.value);

                    return (
                        <Chip
                            key={index}
                            label={c.name}
                            onClick={this.onClick.bind(this, c)}
                            style={{ backgroundColor, color }}
                            color={!c.color ? (selected ? "secondary" : "primary") : undefined}
                        />
                    );
                })}
            </div>
        );
    }
}

export default InputWithChips;
